import mock from '@/fake-db/mock.js'

const data = {
  testimonials: [
    {
      'id': 1,
      'name': 'Brijesh',
      'img': 'https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/products/01.png',
      'description' :'hai brijesh here.'
    }
  ]
}


mock.onGet('/api/testimonials/testimonials').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.testimonials)).reverse()]
})

// POST : Add new Item
mock.onPost('/api/testimonials/testimonials/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.testimonials.length
  let lastIndex = 0
  if (length) {
    lastIndex = data.testimonials[length - 1].id
  }
  item.id = lastIndex + 1

  data.testimonials.push(item)

  return [201, {id: item.id}]
})

// Update Product
mock.onPost(/\/api\/testimonials\/testimonials\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.testimonials.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: Remove Item
mock.onDelete(/\/api\/testimonials\/testimonials\/\d+/).reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.testimonials.findIndex((p) => p.id == itemId)
  data.testimonials.splice(itemIndex, 1)
  return [200]
})
